import { render, staticRenderFns } from "./PageMaster.vue?vue&type=template&id=4d231ad2"
import script from "./PageMaster.vue?vue&type=script&lang=js"
export * from "./PageMaster.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports